import { LinePath } from '@visx/shape';
import { useTranslation } from 'react-i18next';
import type { SecondBucket } from '../perSecond';
import { axisMax, LegendItem, TimeChart, type TimeAxis } from './TimeChart';
import { formatMs, latest } from './values';

/** Jitter (IPDV) per second: the median as a line. */
export const JitterChart = ({ slots, axis }: { slots: SecondBucket[]; axis: TimeAxis }) => {
    const { t, i18n } = useTranslation();
    const last = latest(slots, (b) => b.jitterP50 !== null);
    const yMax = axisMax(
        slots.map((b) => b.jitterP50 ?? 0),
        2
    );

    return (
        <TimeChart
            title={t('TestSuite.Line.Chart.Jitter.Title')}
            ariaLabel={t('TestSuite.Line.Chart.Jitter.Aria', { p50: formatMs(last?.jitterP50, t('TestSuite.Line.NoValue'), i18n.language) })}
            legend={<LegendItem swatch="bg-primary" label={t('TestSuite.Line.Legend.Median')} />}
            axis={axis}
            yMax={yMax}
            unit="ms"
        >
            {({ x, y }) => (
                <LinePath
                    data={slots}
                    defined={(b) => b.jitterP50 !== null}
                    x={(b) => x(b.second + axis.slot / 2)}
                    y={(b) => y(b.jitterP50 ?? 0)}
                    strokeWidth={1.5}
                    className="stroke-primary fill-none"
                />
            )}
        </TimeChart>
    );
};
